import type { ComponentProps, MouseEvent, PointerEvent, ReactNode } from 'react';

import { Button } from '@/components/ui/button';

type BaseButtonProps = Omit<
  ComponentProps<typeof Button>,
  'children' | 'size' | 'variant' | 'colorScheme'
>;

interface BlockActionButtonProps extends BaseButtonProps {
  icon: ReactNode;
  srLabel: string;
  isVisible: boolean;
  showLabel?: boolean;
  label?: string;
}

export function BlockActionButton({
  icon,
  srLabel,
  isVisible,
  showLabel = false,
  label,
  ...props
}: BlockActionButtonProps) {
  const handlePointerDown = (event: PointerEvent<HTMLButtonElement>) => {
    props.onPointerDown?.(event);
    event.stopPropagation();
  };

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    props.onClick?.(event);
    event.stopPropagation();
  };

  return (
    <Button
      {...props}
      size="sm"
      variant="ghost"
      onPointerDown={handlePointerDown}
      onClick={handleClick}
      tabIndex={isVisible ? props.tabIndex : -1}
    >
      {icon}
      {showLabel && label ? <span>{label}</span> : null}
      <span className="sr-only">{srLabel}</span>
    </Button>
  );
}
